import _ from 'lodash';

const initialCVData = {
    firstName: 'Jack',
    lastName: 'Sullivan',
    designation: 'Senior Software Engineer',
    email: 'abc@gmail.com',
    website: 'www.google.com',
    phone: '+41-32-43253245',
    city: 'Downtown',
    country: 'USA',
    profileImageSrc: ''
};

const initialexperienceData = {
    position: 'UX/UI Product Designer',
    company: 'Spotify',
    startDate: '2013-01',
    endDate: '2014-01',
    description: `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. `
};

export const onInitializeCVData = (objectToBeInitialized) => {
    return {
        ...objectToBeInitialized,
        ...initialCVData
    };
};

export const onInitializeExperienceata = (objectToBeInitialized) => {
    return {
        ...objectToBeInitialized,
        experience: [
            _.cloneDeep(initialexperienceData),
            _.cloneDeep(initialexperienceData),
        ]
    };
};
